const Tracking = require('tracking/tracking-controller.js');

/**
 * Tracking Common is used to send some tracking accross
 * all the application. There's not really any condition here.
 * Let's say tomorrow you need an event to know when the current
 * user is authenticated, this could live here.
 * NB: As a reminder, each event sent through the third-party
 * tracking services always tries to send the user data along the event.
 */
(function(root, doc, undefined) {

    'use strict';

    /**
     * Event sent after the page is initialized
     */
    const pageInitEvent = () => {
        Tracking.send('PAGE_INIT');
    };

    // Events list to fire
    pageInitEvent();

})(window, document);
